import { CSSProperties, PropsWithChildren, ReactNode } from 'react'

import { FlexCol, FlexRow } from '../../../../StyledComponents'

interface InfoSectionProps {
  header: ReactNode
  style?: CSSProperties
}

const InfoSection: React.FC<PropsWithChildren<InfoSectionProps>> = ({
  header,
  children,
  style,
}) => (
  <FlexCol
    style={{ borderRadius: '0.5rem', boxShadow: '0.0625rem 0.0625rem 0.5rem #00000030', ...style }}
  >
    <FlexRow
      style={{
        padding: '0.5rem',
        borderBottom: 'solid 1px #00000015',
      }}
    >
      {header}
    </FlexRow>
    <FlexCol style={{ padding: '1rem', gap: '0.5rem' }}>{children}</FlexCol>
  </FlexCol>
)

export default InfoSection
